import { Interval, ModeOfTransport, IntervalDays } from "./FrontendTypes";
import EnumInput from "../components/EnumInput";
import NumberInput from "../components/NumberInput";
import { TrainTrip } from "./FrontendTypes";

function createTrainTrip(toCustomer: boolean): TrainTrip {
    return {
        mot: ModeOfTransport.TRAIN,
        distance: 20,
        frequency: 1,
        interval: Interval.WEEK,
        toCustomer: toCustomer
    }
}

type Props = {
    value: TrainTrip,
    setValue: React.Dispatch<React.SetStateAction<any>>
}

function TrainComponent({value: train, setValue: setTrain}: Props) {

    const setDistance = (newDistance: number) => {
        setTrain({ ...train, distance: newDistance });
    };

    const setFrequency = (newFrequency: number) => {
        setTrain({ ...train, frequency: newFrequency });
    };

    const handleIntervalChange = (newInterval: Interval) => {
        setTrain({ ...train, interval: newInterval });
    };

    return (
        <>
            <NumberInput
                max={999}
                value={train.distance}
                setValue={setDistance}
            />
            <p>km mit öffentlichen Verkehrsmitteln, pro</p>
            <EnumInput
                value={train.interval}
                enumType={Interval}
                onChange={handleIntervalChange}
            />
            <p>ca. </p>
            <NumberInput
                max={IntervalDays[train.interval]}
                value={train.frequency}
                setValue={setFrequency}
            />
            <p> mal</p>
        </>
    );
}

export { type TrainTrip as Type, TrainComponent as Component, createTrainTrip as createTrip };